import { render, staticRenderFns } from "./OtherExpenseList.vue?vue&type=template&id=15b58636&scoped=true"
import script from "./OtherExpenseList.vue?vue&type=script&lang=js"
export * from "./OtherExpenseList.vue?vue&type=script&lang=js"
import style0 from "./OtherExpenseList.vue?vue&type=style&index=0&id=15b58636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b58636",
  null
  
)

export default component.exports